// extracted by mini-css-extract-plugin
export var active = "_74-a";
export var activeIndicator = "_74-9";
export var disabled = "_74-b";
export var fullWidth = "_74-2";
export var lg = "_74-7";
export var md = "_74-6";
export var redoButtonTabGroup = "_74-0";
export var sm = "_74-5";
export var tabButton = "_74-4";
export var tabButtonsContainer = "_74-1";
export var themeDestructive = "_74-d";
export var themeNormal = "_74-c";
export var themeSuccess = "_74-e";
export var xl = "_74-8";
export var xs = "_74-3";